module.exports = __webpack_public_path__ + "img/yydj1.28389aca.webp";